import { cache } from 'react';

import { isDev } from '@/constant/env';
import { defaultLocale, getDictionary, Locale } from '@/lib/i18n/dictionaries';

const getLocale = cache<() => { current?: Locale }>(() => ({
  current: undefined,
}));
const getStaticParamsLocale = () => getLocale().current;

export const setStaticParamsLocale = (value: Locale) => {
  getLocale().current = value;
};

export const getLocaleCache = cache(() => {
  const locale: Locale | undefined = getStaticParamsLocale();

  return locale;
});

export async function getText() {
  const lang = getLocaleCache();

  if (!lang) {
    isDev && console.log('No lang found in "getText"');
  }

  return await getDictionary(lang || defaultLocale);
}

export const getIntlText = (key: string, values?: Record<string, string>) => {
  if (!values) return key;

  return key.replace(/{{\s*(\w+)\s*}}/g, (_, variableName) => {
    return values[variableName] || '';
  });
};
